import script from "./FindPasswordPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FindPasswordPage.vue?vue&type=script&setup=true&lang=ts"

import "./FindPasswordPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__